import _ from "lodash";

const joinSlash = (arr) => {
    return arr.length > 0 ? arr.join("/") : "";
};

export const buildEstimatedFields = (ranges) => {
    let estimatedYearlyCostArr = [];
    let estimatedCostLowRangeArr = [];
    let estimatedCostHighRangeArr = [];
    let estimatedCostLabelArr = [];
    let estimatedCostLabelRangeArr = [];

    let estimatedEnergyUseArr = [];
    let estimatedEnergyUseUomArr = [];
    let estimatedEnergyUseTitleArr = [];
    ranges.forEach((range) => {
        const selectedValue = range.selectedValue;
        let selectedValueYearlyCost = [];
        let selectedValueEnergyUse = [];
        let isCost = false;
        let isUse = false;
        selectedValue.forEach((v) => {
            if (v.value && v.uom) {
                if (v.uom.text === "$") {
                    selectedValueYearlyCost.push(`${v.uom.text}${v.value}`);
                    isCost = true;
                } else {
                    selectedValueEnergyUse.push(`${v.value}`);
                    estimatedEnergyUseUomArr.push(v.uom.text);
                    isUse = true;
                }
            }
        });

        // Set Energy Cost values
        if (selectedValueYearlyCost.length > 0) {
            const costTitle = isCost && range.sliderTitle ? `${range.sliderTitle}: ` : "";
            estimatedYearlyCostArr.push(`${costTitle}${selectedValueYearlyCost.join("-")}`);
        }

        if (isCost && range.low && range.low.value && range.low.uom) {
            estimatedCostLowRangeArr.push(`${range.low.uom.text}${range.low.value}`);
        }

        if (isCost && range.high && range.high.value && range.high.uom) {
            estimatedCostHighRangeArr.push(`${range.high.uom.text}${range.high.value}`);
        }

        if (isCost && range.label) {
            estimatedCostLabelArr.push(range.label);
        }

        if (isCost && range.labelRange) {
            estimatedCostLabelRangeArr.push(range.labelRange);
        }

        // Set Energy Used Values
        if (isUse && range.sliderTitle) {
            estimatedEnergyUseTitleArr.push(range.sliderTitle);
        }

        if (selectedValueEnergyUse.length > 0) {
            estimatedEnergyUseArr.push(selectedValueEnergyUse.join("-"));
        }
    });

    return {
        estimatedYearlyCost: joinSlash(estimatedYearlyCostArr),
        estimatedCostLowRange: joinSlash(estimatedCostLowRangeArr),
        estimatedCostHighRange: joinSlash(estimatedCostHighRangeArr),
        estimatedCostLabel: joinSlash(estimatedCostLabelArr),
        estimatedCostLabelRange: joinSlash(estimatedCostLabelRangeArr),

        estimatedEnergyUseValue: joinSlash(estimatedEnergyUseArr),
        estimatedEnergyUseUom: joinSlash(_.uniq(estimatedEnergyUseUomArr)),
        estimatedEnergyUseTitle: joinSlash(estimatedEnergyUseTitleArr),
    };
};
